import React from "react";
import Card from "../../../components/shared/Card/Card";
import Divider from "../../../components/shared/Divider/Divider";
import {
  formatPrimaryValue,
  formatStdDeviation,
  formatZScore,
  getZScoreColorClass,
} from "../../swing_library/utils/metrics";

export default function MetricCard({
  className,
  collection1,
  collection2,
  isLoading,
  metric1,
  metric2,
  title,
  unit,
}) {
  return (
    <Card
      borderColor="gray200"
      className={`flex flex-col gap-2 p-4 ${className}`}
      color="gray50"
      rounded="xl"
    >
      {isLoading ? (
        <div className="bg-gray200 h-5 w-7/12 rounded-md" />
      ) : (
        <div className="text-gray700 truncate text-sm font-semibold">
          {title}
        </div>
      )}

      <div className="flex w-full items-stretch">
        {/* Collection 1 */}
        <div className="flex min-w-0 flex-1 flex-col gap-1 overflow-hidden pr-2">
          <Card
            className="w-fit max-w-full px-2 py-0.5"
            color="blue50"
            rounded="full"
          >
            <span className="text-blue700 text-xs font-semibold truncate block">
              {collection1?.collectionName ?? "Collection"}
            </span>
          </Card>

          {isLoading ? (
            <div className="bg-gray200 h-6 w-6/12 rounded-md" />
          ) : (
            <div className="text-gray900 text-lg font-semibold">
              {formatPrimaryValue(metric1, unit ?? undefined)}
            </div>
          )}

          <div className="flex flex-row items-center justify-between gap-2">
            <div className="text-gray500 text-xs">Std. Deviation</div>
            {isLoading ? (
              <div className="bg-gray200 h-3 w-5 rounded-md" />
            ) : (
              <div className="text-gray700 text-sm font-semibold">
                {formatStdDeviation(metric1, unit ?? undefined)}
              </div>
            )}
          </div>

          <div className="flex flex-row items-center justify-between gap-2">
            <div className="text-gray500 text-xs">Z-Score</div>
            {isLoading ? (
              <div className="bg-gray200 h-3 w-5 rounded-md" />
            ) : (
              <div
                className={`text-sm font-semibold ${getZScoreColorClass(
                  metric1,
                )}`}
              >
                {formatZScore(metric1)}
              </div>
            )}
          </div>
        </div>

        <Divider className="shrink-0" color="gray200" type="vertical" />

        {/* Collection 2 */}
        <div className="flex min-w-0 flex-1 flex-col gap-1 overflow-hidden pl-2">
          <Card
            className="w-fit max-w-full px-2 py-0.5"
            color="pink50"
            rounded="full"
          >
            <span className="text-pink700 text-xs font-semibold truncate block">
              {collection2?.collectionName ?? "Collection"}
            </span>
          </Card>

          {isLoading ? (
            <div className="bg-gray200 h-6 w-6/12 rounded-md" />
          ) : (
            <div className="text-gray900 text-lg font-semibold">
              {formatPrimaryValue(metric2, unit ?? undefined)}
            </div>
          )}

          <div className="flex flex-row items-center justify-between gap-2">
            <div className="text-gray500 text-xs">Std. Deviation</div>
            {isLoading ? (
              <div className="bg-gray200 h-3 w-5 rounded-md" />
            ) : (
              <div className="text-gray700 text-sm font-semibold">
                {formatStdDeviation(metric2, unit ?? undefined)}
              </div>
            )}
          </div>

          <div className="flex flex-row items-center justify-between gap-2">
            <div className="text-gray500 text-xs">Z-Score</div>
            {isLoading ? (
              <div className="bg-gray200 h-3 w-5 rounded-md" />
            ) : (
              <div
                className={`text-sm font-semibold ${getZScoreColorClass(
                  metric2,
                )}`}
              >
                {formatZScore(metric2)}
              </div>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
}
